import { handleAdminPriceCreated } from "./admin";
import { handleUserPriceCreated } from "./user";

export function handleGoldPriceCreationPatch(state, patch) {
    // console.log('patch in handleGoldPriceCreated: ', patch)
    const { visibility, payload } = patch;

    return handleUserPriceCreated(state, patch);
}